import { Car, Clock, Mail, MapPin, Phone } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

export default function OrariContatti() {
  const { orari, contatti, site } = useContent();

  const rows = [
    { icon: MapPin, label: "Indirizzo", value: site.address, testid: "contact-address" },
    { icon: Phone, label: "Telefono", value: site.phone, testid: "contact-phone" },
    { icon: Mail, label: "Email", value: site.email, testid: "contact-email" },
  ];

  return (
    <section id="contatti" data-testid="contatti-section" className="py-24 lg:py-32 bg-olive-900 text-sand-50 noise-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-terracotta-500 mb-4 block">
              {orari.overline}
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-sand-50 leading-tight">
              {orari.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 divide-y divide-sand-50/10 border-y border-sand-50/10" data-testid="orari-table">
              {orari.rows.map((o) => (
                <div key={o.giorni} className="py-5 flex items-baseline justify-between gap-6">
                  <span className="text-sm font-medium tracking-wide text-sand-100">{o.giorni}</span>
                  <span className={`text-sm font-light text-right ${o.orari === "Chiuso" ? "text-terracotta-500" : "text-sand-100/80"}`}>
                    {o.orari}
                  </span>
                </div>
              ))}
            </div>
            <p className="mt-6 text-sm font-light text-sand-100/60 flex items-center gap-2">
              <Clock className="w-4 h-4" strokeWidth={1.5} aria-hidden="true" />
              {orari.note}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-16 lg:border-l lg:border-sand-50/10">
          <Reveal>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-terracotta-500 mb-4 block">
              {contatti.overline}
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl font-normal tracking-tight text-sand-50 leading-tight">
              {contatti.heading}
            </h2>
          </Reveal>
          <div className="mt-10 space-y-8">
            {rows.map((row, i) => (
              <Reveal key={row.label} delay={0.1 * i}>
                <div className="flex items-start gap-5">
                  <row.icon className="w-5 h-5 mt-1 text-terracotta-500 shrink-0" strokeWidth={1.5} aria-hidden="true" />
                  <div>
                    <p className="text-xs font-semibold tracking-[0.18em] uppercase text-sand-100/50">{row.label}</p>
                    <p data-testid={row.testid} className="mt-2 text-base md:text-lg font-light text-sand-50 leading-relaxed">
                      {row.value}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <div className="flex items-start gap-5">
                <Car className="w-5 h-5 mt-1 text-terracotta-500 shrink-0" strokeWidth={1.5} aria-hidden="true" />
                <div>
                  <p className="text-xs font-semibold tracking-[0.18em] uppercase text-sand-100/50">Parcheggio</p>
                  <p data-testid="contact-parking" className="mt-2 text-base md:text-lg font-light text-sand-50 leading-relaxed">
                    {contatti.parking}
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 border border-sand-50/10">
          <iframe
            data-testid="google-map"
            title={`Mappa — ${site.name}`}
            src={`https://www.google.com/maps?q=${encodeURIComponent(site.address)}&output=embed`}
            className="w-full h-[420px] grayscale-[30%]"
            loading="lazy"
          />
        </div>
      </Reveal>
    </section>
  );
}
